var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.717 10.754H6.38l6.263-6.11c.5-.488.5-1.29 0-1.778a1.3 1.3 0 0 0-1.81 0l-8.458 8.251c-.5.489-.5 1.277 0 1.766l8.459 8.25a1.3 1.3 0 0 0 1.81 0c.5-.488.5-1.276 0-1.765l-6.264-6.11h14.337c.705 0 1.283-.563 1.283-1.252 0-.688-.578-1.252-1.283-1.252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackFill);
export default __webpack_public_path__ + "static/media/arrow_back_fill.b8af25496604ebc1d6f7c097ab380912.svg";
export { ForwardRef as ReactComponent };